import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faDownload } from '@fortawesome/free-solid-svg-icons';

// Styles

import './Styles.scss';

export default function DownloadDocumentButton({label, fileName, fileUrl}) {
  const downloadFile = () => {
    if (fileName && fileUrl) {      
      const url = window.URL.createObjectURL(new Blob([fileUrl]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `${fileName}.pdf`;
      link.click();
    }
  }

  return (
    <div className='btn-download-document'>
        <button onClick={() => downloadFile()} title={`Descargar ${label}`}>
            <p>{label}</p>
            <FontAwesomeIcon icon={faDownload} className='btn-with-icon-icon' />
        </button>
    </div>
  )
}
